import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { syncBillData, refreshBillData } from "../../actions/bill";
import { confirmPromostandardsInvoice } from "../../redux/promostandardsInvoices";
import { trackEvent } from "../../utils/analytics";
import { useIdentity } from "../../hooks";

export const useProjectBillSave = () => {
  const dispatch = useDispatch();
  const identity = useIdentity();

  return useCallback(
    async ({ isNew, isReview, isDirty, bill }) => {
      const firstPO = bill?.orders?.[0]?.purchaseOrders?.[0];
      if (!firstPO) {
        // Bill not related to PO
        // Just do refresh bill data
        await dispatch(refreshBillData(bill.id));
        return;
      }

      const orderId = firstPO.order_id;
      const purchaseOrderId = firstPO.id;

      if (isNew) {
        await dispatch(syncBillData(orderId, bill.id));
      } else {
        await dispatch(refreshBillData(bill.id));
      }

      if (isNew && isReview && !isDirty) {
        if (identity) {
          trackEvent("Bill - Confirm", {
            tenant_id: identity.tenant_id,
            login_email: identity.login_email,
          });
        }
        await dispatch(confirmPromostandardsInvoice(purchaseOrderId));
      }
    },
    [dispatch, identity],
  );
};
